import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isNil } from "lodash";
import { IRAAccountTypes, } from "../../Types";
import setPlanAccountInfoV2 from "../requests/setPlanAccountInfoV2";
import { getPlanAccountsV2KeyMaker } from "./usePlanAccountsV2";
import { getPlanDetailsV2KeyMaker } from "./usePlanDetailsV2";
import { getPlansV2KeyMaker } from "./usePlansV2";
const isIRA = (type) => {
    return IRAAccountTypes.some((t) => t === type);
};
export default function useSetPlanAccountInfoV2(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (input) => {
            if (config === null) {
                throw new Error("no auth");
            }
            const body = createPutRequestBody(input.accountData);
            return setPlanAccountInfoV2(input.planId, input.virtualAccountId, body, config);
        },
        onSuccess: (_, { planId }) => {
            queryClient.invalidateQueries({
                queryKey: getPlanDetailsV2KeyMaker(planId),
            });
            queryClient.invalidateQueries({
                queryKey: getPlanAccountsV2KeyMaker(planId),
            });
            queryClient.invalidateQueries({
                queryKey: getPlansV2KeyMaker(),
            });
        },
    });
    return mutation.mutateAsync;
}
const createPutRequestBody = (incomingAccountData) => {
    const { accountType, accountTitle, accountTarget, jointData, trustData, assetLendingData, } = incomingAccountData;
    const targetGoal = accountTarget?.goal;
    const targetDate = accountTarget?.date;
    let newTargetDate = null;
    if (targetGoal !== undefined &&
        targetDate !== undefined &&
        targetDate !== "--" &&
        targetDate !== "") {
        const [first, second, third] = targetDate.split("-");
        if (first !== undefined && first.length === 4) {
            newTargetDate = targetDate;
        }
        else {
            const year = third;
            const month = first;
            const day = second;
            newTargetDate =
                month !== undefined && day !== undefined && year !== undefined
                    ? `${year}-${month}-${day}`
                    : "";
        }
    }
    let newTargetGoal = null;
    if (targetGoal !== undefined) {
        newTargetGoal = targetGoal;
    }
    let body = {
        accountTitle,
        accountTarget: !isNil(newTargetGoal) && !isNil(newTargetDate)
            ? {
                goal: newTargetGoal,
                date: newTargetDate,
            }
            : null,
        trustData: trustData,
    };
    if (accountType == "Individual") {
        body = {
            accountTitle,
            accountTarget: !isNil(newTargetGoal) && !isNil(newTargetDate)
                ? {
                    goal: newTargetGoal,
                    date: newTargetDate,
                }
                : null,
        };
    }
    else if (isIRA(accountType)) {
        body = {
            accountTitle,
            accountTarget: !isNil(newTargetGoal) && !isNil(newTargetDate)
                ? {
                    goal: newTargetGoal,
                    date: newTargetDate,
                }
                : null,
            retirementData: "retirementData" in incomingAccountData
                ? incomingAccountData.retirementData
                : {},
        };
    }
    else if (accountType === "Joint CP" ||
        accountType === "Joint TE" ||
        accountType === "Joint WROS" ||
        accountType === "Joint TIC") {
        body = {
            accountTitle,
            accountTarget: !isNil(newTargetGoal) && !isNil(newTargetDate)
                ? {
                    goal: newTargetGoal,
                    date: newTargetDate,
                }
                : null,
            jointData: jointData,
        };
    }
    else if (accountType === "Asset Lending") {
        body = {
            accountType: "Asset Lending",
            accountTitle: incomingAccountData.accountTitle,
            accountTarget: !isNil(newTargetGoal) && !isNil(newTargetDate)
                ? {
                    goal: newTargetGoal,
                    date: newTargetDate,
                }
                : null,
            assetLendingData,
        };
    }
    return body;
};
//# sourceMappingURL=useSetPlanAccountInfoV2.js.map